import { cn } from '@/utils';
import { cva } from 'class-variance-authority';

export type BrokerHighlightsVariant = 'dark' | 'light';

export type BrokerHighlightsLayout = 'fixed' | 'fluid' | 'stretch';

const listVariants = cva('flex flex-wrap', {
	variants: {
		variant: {
			dark: 'gap-11',
			light: 'gap-2'
		},
		layout: {
			fixed: '',
			fluid: 'gap-1 xl:gap-2',
			stretch: 'grid grid-cols-2 gap-3 2xl:grid-cols-4'
		}
	},
	defaultVariants: { layout: 'fixed' }
});

const cardVariants = cva('flex shrink-0 flex-col', {
	variants: {
		variant: {
			dark: 'h-[92px] w-[151px] bg-primary-light-4 p-5',
			light: 'h-[118px] w-[203px] rounded-[2px] bg-secondary px-5 py-7'
		},
		layout: {
			fixed: '',
			fluid:
				'w-auto grow min-w-[calc(50%_-_2px)] md:grow-0 md:min-w-[calc(25%_-_3px)] lg:min-w-[151px]',
			stretch: 'h-auto min-h-[118px] w-full'
		}
	},
	defaultVariants: { layout: 'fixed' }
});

const valueVariants = cva(
	'whitespace-nowrap font-matter-sq text-xl font-normal leading-[150%] tracking-[-0.4px]',
	{
		variants: {
			variant: {
				dark: 'text-beige',
				light: 'text-primary-light-4'
			}
		}
	}
);

const labelVariants = cva('font-sans text-xs font-medium leading-[150%]', {
	variants: {
		variant: {
			dark: 'text-white-dark-3',
			light: 'text-primary-light-1'
		},
		layout: {
			fixed: 'whitespace-nowrap',
			fluid: 'whitespace-nowrap',
			stretch: ''
		}
	},
	defaultVariants: { layout: 'fixed' }
});

export function getBrokerHighlightsStyles(
	variant: BrokerHighlightsVariant,
	layout: BrokerHighlightsLayout = 'fixed'
) {
	// `cn` resolve o conflito entre os dois eixos: no layout fluido, o gap e a
	// largura dele vencem os da aparência, que é a ordem em que o cva concatena.
	return {
		list: cn(listVariants({ variant, layout })),
		card: cn(cardVariants({ variant, layout })),
		value: valueVariants({ variant }),
		label: labelVariants({ variant, layout })
	};
}
